import styled from 'styled-components';
import { THEME } from '../../../../themes';

export const MenuItemContainer = styled.li<{ disabled: boolean, isSubMenu: boolean }>`
  box-sizing: border-box;
  outline: none;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 ${THEME.SPACING.BASE};
  cursor: pointer;
  max-width: 320px;
  ${({ disabled }) => {
    if (disabled) {
      return {
        opacity: THEME.OPACITY.MED,
        cursor: 'not-allowed',
      };
    }
    
    return '';
  }}
  :hover,
  :focus {
    background-color: ${THEME.COLORS.ACCENT};
    color: ${THEME.COLORS.PURE_WHITE};
  }
`;
